import React from "react";
import { Path, Svg, View } from "@react-pdf/renderer";

const DocumentDetailCheckBox = ({
  checked,
  children,
}: {
  checked: boolean;
  children: React.ReactNode;
}) => {
  return (
    <View
      style={{
        display: "flex",
        flexDirection: "row",
        gap: "2mm",
      }}
    >
      <View
        style={{
          width: "4mm",
          height: "4mm",
          backgroundColor: checked ? "#CFC0C4" : "transparent",
          border: checked ? "0.2mm solid #CFC0C4" : "0.2mm solid #C6C8CD",
          borderRadius: "1mm",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {checked && (
          <Svg width="3mm" height="2.4mm" viewBox="0 0 12 10">
            <Path
              d="M10.8 1.40002L3.64043 8.60002L1.19995 6.14574"
              stroke="#7B5A63"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </Svg>
        )}
      </View>
      {children}
    </View>
  );
};

export default DocumentDetailCheckBox;
